import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{'hidden': !_ctx.cmOpener.isVisible(_ctx.id)}, "z-10 fixed top-0 left-0 h-screen w-screen"]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cmOpener.close && _ctx.cmOpener.close(...args))),
    ref: "el"
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle(_ctx.cmOpener.style),
      class: _normalizeClass(_ctx.menuClass),
      ref: "el_menu"
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 6)
  ], 2))
}